import React from "react";
import styles from "./Button.module.scss";
import classNames from "classnames";

export default function Button({
  buttonColor,
  buttonText,
  buttonShape,
  onClick,
  disabled = false,
}) {
  const wrapperClasses = classNames([styles.button], {
    [styles.red]: buttonColor === "red",
    [styles.black]: buttonColor === "black",
    [styles.rounded]: buttonShape === "round",
    [styles.squared]: buttonShape === "square",
    [styles.disabled]: disabled,
  });

  return (
    <button onClick={onClick} className={wrapperClasses} disabled={disabled}>
      {buttonText}
    </button>
  );
}
